import React from "react"
import PropTypes from "prop-types"
import { ColumnGroup, Column } from "containers"
import { H4, Space } from "AtomicComponents"
import COLOR_PALETTE from "constants/color-palette"
import componentParser from "AtomicUtils/componentParser"

const MyMazdaPolicies = props => (
  <ColumnGroup
    verticalPadding
    horizontalPadding
    backgroundColor={COLOR_PALETTE.WHITE}
  >
    <Column textAlign="center">
      <H4 withDetails>{props.heading}</H4>
      <Space />
      <div style={styles.list}>{componentParser(props.components)}</div>
    </Column>
  </ColumnGroup>
)

const styles = {
  list: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    marginTop: "3em"
  }
}

MyMazdaPolicies.propTypes = {
  components: PropTypes.array,
  heading: PropTypes.string
}

export default MyMazdaPolicies



// WEBPACK FOOTER //
// ./src/blocks/mymazda/policies/index.jsx